import { render, staticRenderFns } from "./FormSignup.vue?vue&type=template&id=74bc02c0&lang=pug"
import script from "./FormSignup.vue?vue&type=script&lang=js"
export * from "./FormSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports